import React from "react";
import {withRouter} from "react-router-dom";
import {withStyles} from "@material-ui/core/styles";
import Button from "../../../../../../ui/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "../../../../../../ui/Dialog/DialogTitle";
import DialogContent from "../../../../../../ui/Dialog/DialogContent";
import DialogActions from "../../../../../../ui/Dialog/DialogActions";
import AddMasterClassForm from "../AddMasterClassForm";

const styles = theme => ({
  dialog: {
    width: "680px"
  }
});

const AddMasterClassModal = ({
                            open,
                            handleClose,
                            handleConfirm,
                            isCreatingMasterClass,
                            classes
                          }) => {
  const [formData, updateFormData] = React.useState(null);

  const onConfirm = () => {
    handleConfirm(formData);
  };

  const onClose = () => {
    updateFormData(null);
    handleClose();
  };

  return (
    <div>
      <Dialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        PaperProps={{
          className: classes.dialog
        }}
      >
        <DialogTitle onClose={onClose}>Добавить мастер класс</DialogTitle>
        <DialogContent>
          <AddMasterClassForm
            onFormChange={updateFormData}
            disabled={isCreatingMasterClass}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Отмена</Button>
          <Button
            loading={isCreatingMasterClass}
            disabled={isCreatingMasterClass}
            onClick={() => onConfirm()}
            color="green"
          >
            Добавить
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default withStyles(styles)(withRouter(AddMasterClassModal));
